export enum RentalStatusEnum {
  PENDING = 'pending', // THE USERS CREATES A REANTAL
  BOOKED = 'booked', // THE RENTAL BECOME BOOKED UNTILL THE DATE IS REACHED
  // ITEM_DELIVERED = 'item_delivered', // (? THE RENTAL IS DELIVERED WHEN THE OWNER PROVIDES THE ITEM TO THE RENTER (este hay que hacerlo)
  RENTAL_IN_PROGRESS = 'rental_in_progress', // THE DATES OF THE RENTAL ARRIVES AND THE RENTAL IS IN PROGRESS
  RETURNED = 'returned', // THE RENTAL COMPLETED AND RETURNED
  COMPLETED = 'completed', // THE RENTAL IS IN THE PAST
  CANCELED = 'canceled', // THE RENTAL IS CANCELED
}
